import { render, staticRenderFns } from "./DocumentationContent.vue?vue&type=template&id=61f33a1f"
import script from "./DocumentationContent.vue?vue&type=script&lang=js"
export * from "./DocumentationContent.vue?vue&type=script&lang=js"
import style0 from "./DocumentationContent.vue?vue&type=style&index=0&id=61f33a1f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports